import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TogglerComponent } from '@shared/component/form-controls/toggler/toggler.component';
import { TogglerGroupComponent } from '@shared/component/form-controls/toggler/toggler-group/toggler-group.component';



@NgModule({
  declarations: [
    TogglerComponent,
    TogglerGroupComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    TogglerComponent,
    TogglerGroupComponent
  ]
})
export class TogglerModule { }
